// extracted by css-extract-rspack-plugin
export default {"twoColumnWrapper":"two-column-wrapper--iIq93fHapkshg5Ye"};